import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { GoogleBigQueryV2CopySource } from 'app/model/pipeline/copysource/google-bigquery-v2.copysource';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { partitionOptionConst } from 'app/registries/consts/metadata-consts';
import { stringIsNullOrEmpty } from 'app/shared/utils/string.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GoogleBigQueryV2CopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        partitionOption: '*'
    }
})
export class GoogleBigQueryV2CopySourceAdapter extends CopySourceAdapter<
    GoogleBigQueryV2CopySource,
    Model.GoogleBigQueryV2Source
> {
    protected override async _toResource(copySource: GoogleBigQueryV2CopySource): Promise<Model.GoogleBigQueryV2Source> {
        const result: Model.GoogleBigQueryV2Source = this._toTabularResource(
            copySource,
            Metamodel.modelFor(GoogleBigQueryV2CopySource).name
        );
        // Omitted when unset or `None` so existing BigQuery copy activities keep their current payload.
        if (
            !stringIsNullOrEmpty(copySource.partitionOption) &&
            copySource.partitionOption !== partitionOptionConst.none
        ) {
            result.partitionOption = ValueAdapter.toResource(copySource, GoogleBigQueryV2CopySource.PARTITION_OPTION);
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.GoogleBigQueryV2Source,
        copyActivity: CopyActivity
    ): Promise<GoogleBigQueryV2CopySource> {
        const result = this._toTabularModel(
            resource,
            copyActivity,
            GoogleBigQueryV2CopySource.MODEL
        ) as GoogleBigQueryV2CopySource;
        if (resource.partitionOption != null) {
            ValueAdapter.toModel(result, GoogleBigQueryV2CopySource.PARTITION_OPTION, resource.partitionOption);
        }
        return result;
    }
}
